<script setup lang="ts">
// "Handle backend-down gracefully (banner, retry) — never a blank screen" (DESIGN.md section
// 9.2). The SSE handle already retries with backoff on its own; this just surfaces status.
import { computed } from 'vue'
import { tableStore } from '../store/table'

const show = computed(() => tableStore.status === 'disconnected')
</script>

<template>
  <div v-if="show" class="fixed top-0 inset-x-0 z-[100] bg-red-700 text-white text-sm font-semibold px-4 py-2 flex items-center justify-center gap-2">
    <span class="inline-block w-2 h-2 rounded-full bg-white animate-pulse"></span>
    Backend unreachable — retrying…
  </div>
</template>
